"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncEvaluator = void 0;
const Transformation_1 = require("../Transformation");
const RecursiveExpressionEvaluator_1 = require("./RecursiveExpressionEvaluator");
class SyncEvaluator {
    constructor(algExpr, config = {}) {
        this.algExpr = algExpr;
        this.config = config;
        const context = {
            now: config.now || new Date(Date.now()),
            bnode: config.bnode || undefined,
            baseIRI: config.baseIRI || undefined,
            exists: config.exists,
            aggregate: config.aggregate,
        };
        const extensionFunctionCreator = 
        // eslint-disable-next-line unicorn/no-useless-undefined
        config.extensionFunctionCreator || (() => undefined);
        this.expr = (0, Transformation_1.transformAlgebra)(algExpr, { type: 'sync', creator: extensionFunctionCreator });
        this.evaluator = new RecursiveExpressionEvaluator_1.SyncRecursiveEvaluator(context);
    }
    evaluate(mapping) {
        const result = this.evaluator.evaluate(this.expr, mapping);
        return result.toRDF();
    }
    evaluateAsEBV(mapping) {
        const result = this.evaluator.evaluate(this.expr, mapping);
        return result.coerceEBV();
    }
    evaluateAsInternal(mapping) {
        const result = this.evaluator.evaluate(this.expr, mapping);
        return result;
    }
}
exports.SyncEvaluator = SyncEvaluator;
//# sourceMappingURL=SyncEvaluator.js.map